module.exports = __webpack_public_path__ + "assets/img/Affiches_012.74dc686a.jpg";